import { render } from "./LbrxConfirmPopup.vue?vue&type=template&id=50e51c7e&scoped=true"
import script from "./LbrxConfirmPopup.vue?vue&type=script&lang=js"
export * from "./LbrxConfirmPopup.vue?vue&type=script&lang=js"

import "./LbrxConfirmPopup.vue?vue&type=style&index=0&id=50e51c7e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e51c7e"]])

export default __exports__